<section class="smart-strategy-landing" dir="rtl" lang="ar">

  <!-- Hero -->
  <section class="hero" role="banner">
    <div class="hero-media" aria-hidden="true">
      <img
        src="assets/images/sharjah-strategy-landing-hero.png"
        alt=""
        class="hero-image">
      <div class="hero-shade"></div>
    </div>

    <div class="hero-inner">
      <p class="hero-kicker">مطار الشارقة</p>
      <h1 class="hero-title">الاستراتيجية الذكية</h1>
      <p class="hero-subtitle">
        رؤيتك المستقبلية تبدأ من هنا… حيث تتحول البيانات إلى قرارات، والأهداف إلى إنجازات.
      </p>
      <a [routerLink]="['/login']" class="hero-cta">
        <span>تسجيل الدخول</span>
        <i class="pi pi-arrow-left" aria-hidden="true"></i>
      </a>
    </div>
  </section>

  <!-- Vision & Mission -->
  <section class="content-section">
    <div class="container">
      <div class="intro-grid">
        <article class="info-card" aria-labelledby="vision-title">
          <div class="info-card__head">
            <span class="info-card__icon"><i class="pi pi-eye"></i></span>
            <h2 id="vision-title">رؤيتنا</h2>
          </div>
          <p>{{ vision || 'أن نكون جهة رائدة في التميز المؤسسي والتخطيط الاستراتيجي.' }}</p>
        </article>

        <article class="info-card" aria-labelledby="mission-title">
          <div class="info-card__head">
            <span class="info-card__icon"><i class="pi pi-flag"></i></span>
            <h2 id="mission-title">رسالتنا</h2>
          </div>
          <p>{{ mission || 'تطوير وتمكين القدرات المؤسسية لتحقيق الأهداف الاستراتيجية بكفاءة وفعالية.' }}</p>
        </article>
      </div>

      <!-- Values -->
      <div class="values-block" *ngIf="valuesCircle?.length">
        <div class="section-heading">
          <h2>قيمنا</h2>
          <p>الأسس التي نعمل بها لتحقيق التميز المؤسسي</p>
        </div>

        <div class="values-grid">
          <button
            type="button"
            class="value-chip"
            *ngFor="let v of valuesCircle; trackBy: trackByValuePoint"
            (click)="openValueModal(v)">
            <span class="value-chip__icon">
              <i [class]="v.icon || 'pi pi-circle-fill'"></i>
            </span>
            <span class="value-chip__name">{{ v.name }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- Value Detail Modal -->
  <div
    class="modal-overlay"
    *ngIf="isValueModalOpen"
    [@fadeInOut]
    (click)="closeValueModal()">
    <div class="value-modal-container" (click)="$event.stopPropagation()" [@slideIn]>
      <div class="modal-header">
        <div class="value-modal-header-content">
          <div class="value-modal-icon">
            <i [class]="selectedValue?.icon || 'pi pi-circle-fill'"></i>
          </div>
          <h2 class="modal-title">{{ selectedValue?.name }}</h2>
        </div>
        <button
          class="modal-close"
          type="button"
          (click)="closeValueModal()"
          aria-label="إغلاق">
          <i class="pi pi-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <p class="value-modal-description">{{ selectedValue?.description || selectedValue?.name }}</p>
      </div>
    </div>
  </div>

  <!-- Pillars Modal -->
  <div
    class="modal-overlay"
    *ngIf="isPillarsModalOpen"
    [@fadeInOut]
    (click)="closePillarsModal()">
    <div class="modal-container" (click)="$event.stopPropagation()" [@slideIn]>
      <div class="modal-header">
        <h2 class="modal-title">مرتكزاتنا الاستراتيجية</h2>
        <button
          class="modal-close"
          type="button"
          (click)="closePillarsModal()"
          aria-label="إغلاق">
          <i class="pi pi-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="pillars-list">
          <article
            class="pillar-section"
            *ngFor="let pillar of pillars; trackBy: trackByPillar"
            [@fadeInUp]>
            <div class="pillar-header-section">
              <span class="pillar-icon" [style.backgroundColor]="pillar.color || '#C91F3B'">
                <i class="pi pi-chart-line"></i>
              </span>
              <h3 class="pillar-title">{{ pillar.pillar_name }}</h3>
            </div>
            <div class="goals-cards" *ngIf="pillar.goals && pillar.goals.length > 0">
              <div class="goal-card" *ngFor="let goal of pillar.goals; trackBy: trackByGoal">
                <div class="goal-card-icon">
                  <i class="pi pi-check-circle"></i>
                </div>
                <p class="goal-card-text">{{ goal.name }}</p>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</section>
